var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19352_233371)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80532 57.9324C6.44787 57.9324 5.09042 57.3667 4.07234 56.3484L1.58369 53.8593C0.565603 52.841 0 51.4833 0 50.1256C0 48.6547 0.565603 47.297 1.58369 46.2787L32.4656 15.3909L32.5787 15.2777C32.6918 15.2777 32.805 15.1646 32.9181 15.1646H33.2574C33.3706 15.2777 33.3706 15.2777 33.4837 15.2777C34.9543 16.296 36.8773 16.1829 38.1216 15.0514C38.461 14.712 39.0266 14.712 39.2528 15.0514L42.8727 18.672C43.2121 18.8983 43.2121 19.464 42.8727 19.8034C41.7415 21.048 41.6284 22.9714 42.6464 24.4423C42.6464 24.5554 42.6464 24.5554 42.7596 24.6685V25.008C42.7596 25.1211 42.7596 25.2343 42.6464 25.3474L42.5333 25.4605L11.6514 56.3484C10.6333 57.3667 9.27588 57.9324 7.80532 57.9324Z",
    fill: "url(#paint0_linear_19352_233371)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7031 13.4688L53.0513 0.231133C53.3907 -0.108294 53.8432 -0.108294 54.1826 0.231133L57.6893 3.73855C58.0287 4.07797 58.0287 4.53054 57.6893 4.86997L44.4542 18.2208C44.3411 17.9945 44.1148 17.7682 44.0017 17.5419L40.3818 13.9214C40.1556 13.8082 39.9294 13.5819 39.7031 13.4688Z",
    fill: "url(#paint1_linear_19352_233371)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19352_233371",
    x1: 0,
    y1: 36.3646,
    x2: 43.1272,
    y2: 36.3646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19352_233371",
    x1: 39.7031,
    y1: 9.09867,
    x2: 57.9438,
    y2: 9.09867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3B88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19352_233371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.9233,
    height: 57.9233,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatting);
export default __webpack_public_path__ + "static/media/batting.1f577469162481a352a9923d470d89a6.svg";
export { ForwardRef as ReactComponent };